import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import useReferralCreditsQuery from 'api/queries/useReferralCreditsQuery';
import { AnalyticsEventNames } from 'constants/analytics';
import NanoBanner from 'honeydew/NanoBanner';
import { trackEvent } from 'utils/analyticsUtils';

import { SignupPromoTermsModal } from './SignupPromoTermsModal';
import { TermsAndConditions } from './TermsAndConditions';
import { getNanobarText } from './utils';

export function SignupNanoBanner({ appliedPromoCodeData, setShowPromoTermsModal, showPromoTermsModal }) {
    const trackedRef = useRef(false);
    const { data: referrals = {}, isLoading: isReferralsLoading } = useReferralCreditsQuery();
    const { referralRewards } = referrals ?? {};

    const nanobarText = getNanobarText({ appliedPromoCodeData, referralRewards });
    const showSignupNanoBanner = Boolean(!isReferralsLoading && nanobarText && appliedPromoCodeData);
    const NanobarTerms = (
        <TermsAndConditions appliedPromoCodeData={appliedPromoCodeData} referralRewards={referralRewards} />
    );

    useEffect(() => {
        if (!trackedRef.current && showSignupNanoBanner) {
            trackedRef.current = true;

            trackEvent(AnalyticsEventNames.PROMO_BANNER_EXPOSURE, {
                path: window.location.pathname,
                promo_code: appliedPromoCodeData?.disc?.code,
                surface: 'signup',
            });
        }
    }, [showSignupNanoBanner, appliedPromoCodeData?.disc?.code]);

    if (isReferralsLoading || !nanobarText) {
        return null;
    }

    return (
        <>
            <SignupPromoTermsModal
                showPromoTermsModal={showPromoTermsModal}
                setShowPromoTermsModal={setShowPromoTermsModal}
                termsAndConditions={NanobarTerms}
            />
            {appliedPromoCodeData && (
                <NanoBanner boldCopy={nanobarText} link="See details" onClick={() => setShowPromoTermsModal(true)} />
            )}
        </>
    );
}

SignupNanoBanner.propTypes = {
    appliedPromoCodeData: PropTypes.shape({
        claimBy: PropTypes.shape({
            date: PropTypes.string,
        }),
        disc: PropTypes.shape({
            code: PropTypes.string,
            nanobarTerms: PropTypes.string,
            nanobarText: PropTypes.string,
            type: PropTypes.string,
            valid: PropTypes.bool,
            value: PropTypes.number,
        }),
    }),
    setShowPromoTermsModal: PropTypes.func.isRequired,
    showPromoTermsModal: PropTypes.bool.isRequired,
};

SignupNanoBanner.defaultProps = {
    appliedPromoCodeData: undefined,
};
